export const createFileFromImgURL = (imgUrl, fileName = "default_name.png") => {
  const dataURI = imgUrl;
  const byteString = atob(dataURI.split(",")[1]);
  const mimeString = dataURI.split(",")[0].split(":")[1].split(";")[0];
  const arrayBuffer = new ArrayBuffer(byteString.length);
  const uint8Array = new Uint8Array(arrayBuffer);

  for (let i = 0; i < byteString.length; i++) {
    uint8Array[i] = byteString.charCodeAt(i);
  }

  const blob = new Blob([arrayBuffer], { type: mimeString });
  return new File([blob], fileName, { type: mimeString });
};

export const normalizePictureForm = (form) => {
  const parsedYear = Number(form.year);
  return {
    ...form,
    year: form.year === "" || form.year == null || Number.isNaN(parsedYear) ? null : parsedYear,
    isMain: Boolean(form.isMain),
  };
};
